export default "__VITE_ASSET__8f402aa2__"